<template>
  <v-card outlined class="rounded-lg">
    <v-img v-if="!short" :src="'/static/calendarEventImages/img_birthday_1x.jpg'" height="100px">
      <v-card-title class="white--text">Geburtstagsliste</v-card-title>
    </v-img>
    <v-card-title v-else>Geburtstagsliste</v-card-title>
    <v-card-text class="pa-0">
      <div class="body-2 pa-4" v-if="geburtstage.length === 0">Keine anstehenden Geburtstage</div>
      <v-simple-table fixed-header dense class="mb-0 rounded-lg">
        <tbody>
          <tr
            v-for="item in geburtstage"
            :key="item.id"
            @click="
              bbr = item.bbr;
              showKontakt = true;
            "
          >
            <td>{{ $filters.date(item.geburtsdatum, "DD.MM.") }}</td>
            <td>{{ $filters.user(item.bbrID, bbrbbr) }} ({{ item.alter }} Jahre)</td>
          </tr>
        </tbody>
      </v-simple-table>

      <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: ["short"],
    data() {
      return {
        bbr: {},
        showKontakt: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      geburtstage() {
        const bbrbbr = this.$store.getters["bbrbbr/nurBbrbbr"];
        const heute = new Date().setDate(new Date().getDate() - 1);
        const ergebnis = bbrbbr
          .filter((bbr) => bbr.geburtsdatum)
          .map((bbr) => {
            const geburtsdatum = new Date(bbr.geburtsdatum);
            const alter = new Date().getFullYear() - geburtsdatum.getFullYear();
            return {
              bbr: bbr,
              bbrID: bbr.id,
              geburtsdatum,
              alter,
            };
          })
          .flatMap((item) => {
            const newItem1 = {
              ...item,
              geburtsdatum: new Date(new Date(item.geburtsdatum).setFullYear(new Date().getFullYear())),
            };
            const newItem2 = {
              ...item,
              geburtsdatum: new Date(new Date(item.geburtsdatum).setFullYear(new Date().getFullYear() + 1)),
            };
            return [newItem1, newItem2];
          })
          .filter((item) => item.geburtsdatum >= heute)
          .sort((a, b) => a.geburtsdatum - b.geburtsdatum)
          .slice(0, this.short ? 4 : 10);
        return ergebnis;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// geburtstage.vue?04d165ce